import { createFileRoute } from '@tanstack/react-router';
import UserPanel from '@piwikpro/user-panel/src/UserPanel';

export const Route = createFileRoute('/_secured/profile')({
  component: UserPanel,
});
